import {
    AppBar,
    Box,
    Button,
    Chip,
    Container, Grid,
    IconButton, Link,
    Menu,
    MenuItem, Slide,
    Toolbar,
    Tooltip, useScrollTrigger
}
    from "@mui/material";
import URI from "../constants/URI";
import React from "react";
import MenuIcon from '@mui/icons-material/Menu';
import LanguageSelect from "./LanguageSelect";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import PropTypes from "prop-types";


const TopBar = ({currentLang, changeLang}) => {
    const {t} = useTranslation();

    const navigate = useNavigate();

    const pages = [
        {uri: URI.HOME, title: t("home")},
        {uri: URI.QUIZ, title: t("take_quiz")},
        {uri: URI.SCOREBOARD, title: t("scoreboard")},
        {uri: URI.REVIEW, title: t("review")},
        {uri: URI.CONTACT, title: t("contact")}
    ]

    const smPages = [
        {uri: URI.HOME, title: t("home")},
        {uri: URI.QUIZ, title: t("take_quiz")},
        {uri: URI.SCOREBOARD, title: t("scoreboard")},
        {uri: URI.REVIEW, title: t("review")},
        {uri: URI.CONTACT, title: t("contact")},
        {uri: URI.LOGIN, title: t("log_in")},
        {uri: URI.SIGNUP, title: t("sign_up")}
    ]


    const onLogout = () => {
        window.localStorage.clear();
        navigate(URI.HOME);
    };

    // Responsive App Bar
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };


    return (
            <AppBar position="static">
                <Container maxWidth={"xl"}>
                    <Toolbar disableGutters id="toolbar">
                        <Box sx={{flexGrow: 1, display: {xs: 'flex', md: 'none'}}}>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                color="inherit"
                            >
                                <MenuIcon/>
                            </IconButton>
                            <Menu
                                id="menu-pages"
                                anchorEl={anchorElNav}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                sx={{
                                    display: {xs: 'block', md: 'none'},
                                }}
                            >
                                {smPages.map(({uri, title}) => (
                                    <MenuItem key={uri} onClick={handleCloseNavMenu}>
                                        <Link textAlign="center" underline="none"
                                              onClick={() => navigate(uri)}>{title}</Link>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>
                        <Box sx={{flexGrow: 1, display: {xs: 'none', md: 'flex'}}}>
                            {pages.map(({uri, title}) => (
                                <Button
                                    key={uri}
                                    onClick={() => {
                                        handleCloseNavMenu();
                                        navigate(uri);
                                    }}
                                    sx={{my: 2, color: 'white', display: 'block'}}
                                >
                                    {title}
                                </Button>
                            ))}
                        </Box>

                        {window.localStorage.getItem("token") === null ?
                            (
                                <Box sx={{flexGrow: 0, display: {xs: 'none', md: 'flex'}}}>
                                    <Grid container spacing={1} justifyContent="flex-end">
                                        <Grid item>
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                onClick={() => navigate(URI.LOGIN)}
                                            >
                                                {t("log_in")}
                                            </Button>
                                        </Grid>
                                        <Grid item>
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                onClick={() => navigate(URI.SIGNUP)}
                                            >
                                                {t("sign_up")}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            ) : (
                                <Box sx={{flexGrow: 0}}>
                                    <Tooltip title="Open settings">
                                        <IconButton onClick={handleOpenUserMenu} sx={{p: 0}}>
                                            <Chip sx={{color: "white"}} label={window.localStorage.getItem("username")}
                                                  variant="outlined"/>
                                        </IconButton>
                                    </Tooltip>
                                    <Menu
                                        sx={{mt: '45px'}}
                                        id="menu-user"
                                        anchorEl={anchorElUser}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        open={Boolean(anchorElUser)}
                                        onClose={handleCloseUserMenu}
                                    >
                                        <MenuItem onClick={handleCloseUserMenu}>
                                            <Link textAlign="center" underline="none" variant="button" color="white"
                                                  onClick={() => navigate(URI.PREFERENCES)}>{t("preferences")}</Link>
                                        </MenuItem>
                                        <MenuItem onClick={handleCloseUserMenu}>
                                            <Link textAlign="center" underline="none" variant="button" color="white"
                                                  onClick={onLogout}>{t("sign_out")}</Link>
                                        </MenuItem>
                                    </Menu>
                                </Box>
                            )
                        }
                        <Box sx={{ml: 2}}>
                            <LanguageSelect currentLang={currentLang} changeLang={changeLang}/>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
    );
};

export default TopBar;